import { forEach, split } from 'ramda';
import OfficialsConnectLogin from '../views/officials-connect/pages/Login';
import OfficialsConnectNewPassword from '../views/officials-connect/pages/NewPassword';
import SportsConnectLogin from '../views/sports-connect/pages/Login';
import SportsConnectNewPassword from '../views/sports-connect/pages/NewPassword';
import SportsConnectForgotPassword from '../views/sports-connect/pages/ForgotPassword';
import SportsConnectForgotPasswordConfirm from '../views/sports-connect/pages/ForgotPasswordConfirm';
import * as Config from '../config/config';

const sportsConnectIds = split(',', Config.SPORTS_CONNECT_CLIENT_ID);

const configuration = {
  [Config.OFFICIALS_CONNECT_CLIENT_ID]: {
    login: OfficialsConnectLogin,
    new_password: OfficialsConnectNewPassword
  }
};

forEach(id => {
  configuration[id] = {
    login: SportsConnectLogin,
    new_password: SportsConnectNewPassword,
    forgot_password: SportsConnectForgotPassword,
    forgot_password_confirm: SportsConnectForgotPasswordConfirm
  };
}, sportsConnectIds);

export default configuration;



// WEBPACK FOOTER //
// ./src/config/ClientIdConfig.js